export const categoryLabel = (value) => {
    const text = String(value ?? "").trim().toLocaleLowerCase("sr-Latn");
    return text.charAt(0).toLocaleUpperCase("sr-Latn") + text.slice(1);
};
